// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3dBXQ","left":"StickyBox_left__2zgIw","right":"StickyBox_right__2xszI"};